// no itx for this file

import SignalType from "./SignalType";

export default class SignalTypes {
  static Ignored = new SignalType({
    name: "Ignored",
    description: { en: "Ignored" },
    isIgnored: true,
  });

  static Unknown = new SignalType({
    name: "Unknown",
    description: { en: "Unknown" },
    isIgnored: true,
  });

  // Schalten

  static Switch = new SignalType({
    name: "Switch",
    description: { en: "Switch" },
    isStatus: false,
    dpts: ["dpst-1"],
  });

  static SwitchInverted = new SignalType({
    name: "SwitchInverted",
    description: { en: "Switch Inverted" },
    isStatus: false,
    isIgnored: true,
    dpts: ["dpst-1"],
  });
  static SwitchStatus = new SignalType({
    name: "SwitchStatus",
    description: { en: "Switch Status" },
    isStatus: true,
    dpts: ["dpst-1"],
  });
  static SwitchStatusInverted = new SignalType({
    name: "SwitchStatusInverted",
    description: { en: "Switch Status Inverted" },
    isStatus: true,
    isIgnored: true,
    dpts: ["dpst-1"],
  });
  static StaircaseLight = new SignalType({
    super: SignalTypes.Switch,
    name: "StaircaseLight",
    description: { en: "Staircase Light" },
    isIgnored: true,
    dpts: ["dpst-1"],
  });
  static delayTime = new SignalType({
    name: "delayTime",
    description: { en: "Delay Time" },
    dpts: ["dpst-7-5"],
  });
  static Pulse = new SignalType({
    super: SignalTypes.Switch,
    name: "Pulse",
    description: { en: "Pulse" },
    isIgnored: true,
  });

  static BlinkingState = new SignalType({
    name: "BlinkingState",
    description: { en: "Blinking State" },
    isStatus: true,
    isIgnored: true,
  });

  // Dimmen

  static SendValueStatus = new SignalType({
    // everytime brightness? shouldnt be brightness an extra signalType?
    name: "SendValueStatus",
    description: { en: "Send Value Status" },
  });

  static DimValue = new SignalType({
    // everytime brightness? shouldnt be brightness an extra signalType?
    name: "DimValue",
    description: { en: "Dim Value" },
  });
  static DimValueStatus = new SignalType({
    name: "DimValueStatus",
    description: { en: "Dim Value Status" },
    isStatus: true,
  });

  static DimStep = new SignalType({
    name: "DimStep",
    description: { en: "Dim Step" },
  });

  static DimRemessure = new SignalType({
    name: "DimRemessure",
    description: { en: "Dim Remessure" },
  });
  /// präsenz Melder ??????????????????????????????????????????????????????????????????????
  static Brightness_Current = new SignalType({
    name: "Brightness_Current",
    description: { en: "Brightness Current" },
    dpts: ["dpst-9-1"],
  });
  static Brightness_CurrentStatus = new SignalType({
    name: "Brightness_CurrentStatus",
    description: { en: "Brightness Current Status" },
    isStatus: true,
    dpts: ["dpst-9-1"],
  });

  // Tuneable White

  static ColorTemperatureStep = new SignalType({
    name: "ColorTemperatureStep",
    description: { en: "Color Temperature Step" },
  });

  static ColorTemperatureKelvin = new SignalType({
    name: "ColorTemperatureKelvin",
    description: { en: "Color Temperature Kelvin Value" },
  });

  static ColorTemperatureKelvinStatus = new SignalType({
    name: "ColorTemperatureKelvinStatus",
    description: { en: "Color Temperature Kelvin Status" },
    isStatus: true,
  });

  static ColorTemperaturePercent = new SignalType({
    name: "ColorTemperaturePercent",
    description: { en: "Color Temperature Percent Value" },
  });

  static ColorTemperaturePercentStatus = new SignalType({
    name: "ColorTemperaturePercentStatus",
    description: { en: "Color Temperature Percent Status" },
    isStatus: true,
  });

  static TWColdWhiteValue = new SignalType({
    name: "TWColdWhiteValue",
    description: { en: "TW Cold White Value" },
  });

  static TWColdWhiteValueStatus = new SignalType({
    name: "TWColdWhiteValueStatus",
    description: { en: "TW Cold White Value Status" },
    isStatus: true,
  });

  static TWColdWhiteStep = new SignalType({
    name: "TWColdWhiteStep",
    description: { en: "TW Cold White Step" },
  });
  static TWWarmWhiteValue = new SignalType({
    name: "TWWarmWhiteValue",
    description: { en: "TW Warm White Value" },
  });

  static TWWarmWhiteValueStatus = new SignalType({
    name: "TWWarmWhiteValueStatus",
    description: { en: "TW Warm White Value Status" },
    isStatus: true,
  });
  static TWWarmWhiteStep = new SignalType({
    name: "TWWarmWhiteStep",
    description: { en: "TW Warm White Step" },
  });
  static TunableWhiteTransitionValue = new SignalType({
    name: "TunableWhiteTransitionValue",
    description: { en: "Tunable White Transition Value" },
  });
  static TunableWhiteTransitionStep = new SignalType({
    name: "TunableWhiteTransitionStep",
    description: { en: "Tunable White Transition Step" },
  });
  static TunableWhiteTransitionValueStatus = new SignalType({
    name: "TunableWhiteTransitionValueStatus",
    description: { en: "Tunable White Transition Value Status" },
    isStatus: true,
  });

  static TunableWhiteBrightnessTransition249_600 = new SignalType({
    name: "TunableWhiteBrightnessTransition249_600",
    description: { en: "Tunable White Brightness Transition 249-600" },
  });

  //... RGB

  static RGBValue = new SignalType({
    name: "RGBValue",
    description: { en: "RGB Value" },
  });
  static RGBValue6Byte = new SignalType({
    name: "RGBValue6Byte",
    description: { en: "RGB Value 6 Byte" },
    isIgnored: true,
  });

  static RGBStep = new SignalType({
    name: "RGBStep",
    description: { en: "RGB Step" },
  });

  static RGBRelative_Control254_600 = new SignalType({
    name: "RGBRelative_Control254_600",
    description: { en: "RGB Relative Control 254-600" },
  });

  static RGBValueStatus = new SignalType({
    name: "RGBValueStatus",
    description: { en: "RGB Value Status" },
    isStatus: true,
    isIgnored: true,
  });
  static RGBValueStatus6Byte = new SignalType({
    name: "RGBValueStatus6Byte",
    description: { en: "RGB Value Status 6 Byte" },
    isStatus: true,
    isIgnored: true,
  });

  static HSVValue = new SignalType({
    name: "HSVValue",
    description: { en: "HSV Value" },
  });
  static HSVStep = new SignalType({
    name: "HSVStep",
    description: { en: "HSV Step" },
  });

  static HSVValueStatus = new SignalType({
    name: "HSVValueStatus",
    description: { en: "HSV Value Status" },
  });

  static HSVValue6Byte = new SignalType({
    name: "HSVValue6Byte",
    description: { en: "HSV Value 6 Byte" },
  });
  static HSVValueStatus6Byte = new SignalType({
    name: "HSVValueStatus6Byte",
    description: { en: "HSV Value Status 6 Byte" },
  });

  static RGBRedSwitch = new SignalType({
    name: "RGBRedSwitch",
    description: { en: "RGB Red Switch" },
  });
  static RGBRedSwitchStatus = new SignalType({
    name: "RGBRedSwitchStatus",
    description: { en: "RGB Red switch Status" },
    isStatus: true,
  });
  static RGBRedValue = new SignalType({
    name: "RGBRedValue",
    description: { en: "RGB Red Value" },
  });
  static RGBRedStep = new SignalType({
    name: "RGBRedStep",
    description: { en: "RGB Red Step" },
  });
  static RGBRedValueStatus = new SignalType({
    name: "RGBRedValueStatus",
    description: { en: "RGB Red Value Status" },
    isStatus: true,
  });

  static RGBGreenSwitch = new SignalType({
    name: "RGBGreenSwitch",
    description: { en: "RGB Green Switch" },
  });
  static RGBGreenSwitchStatus = new SignalType({
    name: "RGBGreenSwitchStatus",
    description: { en: "RGB Green switch Status" },
    isStatus: true,
  });
  static RGBGreenValue = new SignalType({
    name: "RGBGreenValue",
    description: { en: "RGB Green Value" },
  });
  static RGBGreenStep = new SignalType({
    name: "RGBGreenStep",
    description: { en: "RGB Green Step" },
  });
  static RGBGreenValueStatus = new SignalType({
    name: "RGBGreenValueStatus",
    description: { en: "RGB Green Value Status" },
    isStatus: true,
  });

  static RGBBlueSwitch = new SignalType({
    name: "RGBBlueSwitch",
    description: { en: "RGB Blue Switch" },
  });
  static RGBBlueSwitchStatus = new SignalType({
    name: "RGBBlueSwitchStatus",
    description: { en: "RGB Blue switch Status" },
    isStatus: true,
  });
  static RGBBlueValue = new SignalType({
    name: "RGBBlueValue",
    description: { en: "RGB Blue Value" },
  });
  static RGBBlueStep = new SignalType({
    name: "RGBBlueStep",
    description: { en: "RGB Blue Step" },
  });
  static RGBBlueValueStatus = new SignalType({
    name: "RGBBlueValueStatus",
    description: { en: "RGB Blue Value Status" },
    isStatus: true,
  });
  static RGBWhiteSwitch = new SignalType({
    name: "RGBWhiteSwitch",
    description: { en: "RGB White Switch" },
  });
  static RGBWhiteValue = new SignalType({
    name: "RGBWhiteValue",
    description: { en: "RGB White Value" },
  });
  static RGBWhiteStep = new SignalType({
    name: "RGBWhiteStep",
    description: { en: "RGB White Step" },
  });

  static RGBWhiteSwitchStatus = new SignalType({
    name: "RGBWhiteSwitchStatus",
    description: { en: "RGB White switch Status" },
    isStatus: true,
  });

  static RGBWhiteValueStatus = new SignalType({
    name: "RGBWhiteValueStatus",
    description: { en: "RGB White Value Status" },
    isStatus: true,
  });

  //... RGBW
  // static RGBWStatus = new SignalType({
  //   name: "RGBWStatus",
  //   description: { en: "RGBW Status" },
  //   isStatus: true,
  //   isIgnored: true,
  // });

  static HSV_ColorValue = new SignalType({
    name: "HSV_ColorValue",
    description: { en: "HSV Color Value" },
  });
  static HSV_ColorValueStatus = new SignalType({
    name: "HSV_ColorValueStatus",
    description: { en: "HSV Color Value Status" },
    isStatus: true,
  });

  static HSV_HueValue = new SignalType({
    name: "HSV_HueValue",
    description: { en: "HSV Hue Value" },
  });
  static HSV_HueStep = new SignalType({
    name: "HSV_HueStep",
    description: { en: "HSV Hue Step" },
  });
  static HSV_HueValueStatus = new SignalType({
    name: "HSV_HueValueStatus",
    description: { en: "HSV Hue Value Status" },
    isStatus: true,
  });

  static HSV_SaturationValue = new SignalType({
    name: "HSV_SaturationValue",
    description: { en: "HSV Saturation Value" },
  });
  static HSV_SaturationStep = new SignalType({
    name: "HSV_SaturationStep",
    description: { en: "HSV Saturation Step" },
  });
  static HSV_SaturationValueStatus = new SignalType({
    name: "HSV_SaturationValueStatus",
    description: { en: "HSV Saturation Value Status" },
    isStatus: true,
  });

  // static HSV_BrightnessValue = new SignalType({
  //   name: "HSV_BrightnessValue",
  //   description: { en: "HSV_BrightnessValue" },
  // });
  // static HSV_BrightnessStep = new SignalType({
  //   name: "HSV_BrightnessStep",
  //   description: { en: "HSV_BrightnessStep" },
  // });
  // static HSV_BrightnessValueStatus = new SignalType({
  //   name: "HSV_BrightnessValueStatus",
  //   description: { en: "HSV_BrightnessValue Status" },
  //   isStatus: true,
  // });

  // Heating

  static Temperature_Current = new SignalType({
    name: "Temperature_Current",
    description: { en: "Temperature Current" },
    isStatus: true,
  });

  //
  // Achtung: "." Syntax ......
  //
  // Beim Matchen von Signaltypen
  // erfolgt der Vergleich nur bis zum "."
  //
  // Das heisst "Temperature_Current.Display" wird "Temperature_Current" matchen
  // Dadurch wird für beide eine gemeinsame GruppenAddresse verwendet
  //

  static Temperature_CurrentDisplay = new SignalType({
    name: "Temperature_Current.Display",
    description: { en: "Temperature Current Display" },
    isStatus: true,
  });

  static Temperature_TargetShift_9 = new SignalType({
    name: "Temperature_TargetShift_9",
    description: { en: "Temperature Target Shift (9-2) 2 Bytes" },
  });

  static Temperature_TargetShift_9_Status = new SignalType({
    name: "Temperature_TargetShift_9_Status",
    description: { en: "Temperature Target Shift Status (9-2) 2 Bytes" },
    isStatus: true,
  });

  static Temperature_TargetShift_6 = new SignalType({
    name: "Temperature_TargetShift_6",
    description: { en: "Temperature Target Shift (6-10/1 Byte)" },
  });
  static Temperature_TargetShift_6_Status = new SignalType({
    name: "Temperature_TargetShift_6_Status",
    description: { en: "Temperature Target Shift Status (6-10/1 Byte)" },
    isStatus: true,
  });

  static Temperature_TargetStep_1 = new SignalType({
    name: "Temperature_TargetStep_1",
    description: { en: "Temperature Target Step 1Bit" },
  });

  static Temperature_Target = new SignalType({
    name: "Temperature_Target",
    description: { en: "Temperature Target" },
    dpts: ["dpst-9", "dpst-5"],
  });
  static Temperature_TargetComfort = new SignalType({
    name: "Temperature_TargetComfort",
    description: { en: "Temperature Target Comfort" },
  });

  static Temperature_TargetStatus = new SignalType({
    name: "Temperature_TargetStatus",
    description: { en: "Temperature Target Status" },
    isStatus: true,
  });

  // static Temperature_TargetStatus_5 = new SignalType({
  //   name: "Temperature_TargetStatus",
  //   description: { en: "Temperature Target Status 1 Byte" },
  //   isStatus: true,
  // });

  static Temperature_TargetComfortStatus = new SignalType({
    name: "Temperature_TargetComfortStatus",
    description: { en: "Temperature Target Comfort Status" },
    isStatus: true,
  });

  static Temperature_Max = new SignalType({
    name: "Temperature_Max",
    description: { en: "Temperature Max" },
    isIgnored: true,
  });

  static Temperature_Min = new SignalType({
    name: "Temperature_Min",
    description: { en: "Temperature Min" },
    isIgnored: true,
  });

  static Temperature_Heating_Status = new SignalType({
    name: "Temperature_Heating_Status",
    description: { en: "Temperature Heating Status" },
    isStatus: true,
  });

  static Temperature_MinMaxReset = new SignalType({
    name: "Temperature_MinMaxReset",
    description: { en: "Temperature Min Max Reset" },
    isIgnored: true,
  });

  static OperationMode = new SignalType({
    name: "OperationMode",
    description: { en: "Operation Mode" },
    globalGroupAdress: "31/1/20",
  });

  static OperationMode_Status = new SignalType({
    name: "OperationMode_Status",
    isStatus: true,
    description: { en: "Operation Mode Status" },
    globalGroupAdress: "31/1/26",
  });

  static OperationMode_Comfort = new SignalType({
    name: "OperationMode_Comfort",
    description: { en: "Operation Mode Comfort" },
    globalGroupAdress: "31/1/21",
  });
  static OperationMode_Night = new SignalType({
    name: "OperationMode_Night",
    description: { en: "Operation Mode Night" },
    globalGroupAdress: "31/1/22",
  });
  static OperationMode_FrostProtection = new SignalType({
    name: "OperationMode_FrostProtection ",
    description: { en: "Operation Mode Frost Protection" },
    globalGroupAdress: "31/1/23",
  });
  static OperationMode_Eco = new SignalType({
    name: "OperationMode_Eco",
    description: { en: "Operation Mode Eco" },
    globalGroupAdress: "31/1/24",
  });
  static OperationMode_HeatProtection = new SignalType({
    name: "OperationMode_HeatProtection",
    description: { en: "Operation Mode Heat Protection" },
    globalGroupAdress: "31/1/25",
  });
  //prozent
  static Temperature_ControlValueStatus = new SignalType({
    name: "Temperature_ControlValueStatus",
    description: { en: "Temperature Control Value Status (2 bytes/5-1)" },
  });
  //prozent
  static Temperature_ControlValue = new SignalType({
    name: "Temperature_ControlValue",
    description: { en: "Temperature Control Value (2 bytes/5-1)" },
  });

  /// on/off
  static Temperature_ValveStateStatus = new SignalType({
    name: "Temperature_ValveStateStatus",
    description: { en: "Temperature Valve State Status (1 bit)" },
  });

  /// on/off
  static Temperature_ValveState = new SignalType({
    name: "Temperature_ValveState",
    description: { en: "Temperature Valve State (1 bit)" },
  });

  // blind
  static BlindMove = new SignalType({
    name: "BlindMove",
    description: { en: "Blind Move" },
  });

  static BlindStopStep = new SignalType({
    name: "BlindStopStep",
    description: { en: "Blind Stop Step" },
  });

  static BlindMoveUp = new SignalType({
    name: "BlindMoveUp",
    description: { en: "Blind Move Up" },
    isIgnored: true,
  });

  static BlindMoveDown = new SignalType({
    name: "BlindMoveDown",
    description: { en: "Blind Move Down" },
    isIgnored: true,
  });

  static BlindStartRefDrive = new SignalType({
    name: "BlindStartRefDrive",
    description: { en: "Blind Start Ref Drive" },
  });

  static BlindMoveStatus = new SignalType({
    name: "BlindMoveStatus",
    description: { en: "Blind Move Status" },
    isStatus: true,
    isIgnored: true,
  });

  static BlindMoveUpStatus = new SignalType({
    name: "BlindMoveUpStatus",
    description: { en: "Blind Move Up Status" },
    isStatus: true,
    isIgnored: true,
  });

  static BlindMoveDownStatus = new SignalType({
    name: "BlindMoveDownStatus",
    description: { en: "Blind Move Down Status" },
    isStatus: true,
    isIgnored: true,
  });

  static BlindPosition = new SignalType({
    name: "BlindPosition",
    description: { en: "Blind Position" },
  });

  static BlindPositionStatus = new SignalType({
    name: "BlindPositionStatus",
    description: { en: "Blind Position Status" },
    isStatus: true,
  });

  static BlindDirectionValue = new SignalType({
    name: "BlindDirectionValue",
    description: { en: "Blind Direction Value" },
    isIgnored: true,
  });

  static BlindDirectionStatus = new SignalType({
    name: "BlindDirectionStatus",
    description: { en: "Blind Direction Status" },
    isStatus: true,
  });

  static BlindDownRunning = new SignalType({
    name: "BlindDownRunning",
    description: { en: "Blind Down Running" },
    isIgnored: true,
  });

  static BlindUpRunning = new SignalType({
    name: "BlindUpRunning",
    description: { en: "Blind Up Running" },
    isIgnored: true,
    dpts: ["dpst-1"],
  });

  static BlindTopStatus = new SignalType({
    name: "BlindTopStatus",
    description: { en: "Blind Top Status" },
    isStatus: true,
  });

  static BlindBottomStatus = new SignalType({
    name: "BlindBottomStatus",
    description: { en: "Blind Bottom Status" },
    isStatus: true,
  });

  static BlindSingleObjectControl = new SignalType({
    name: "BlindSingleObjectControl",
    description: { en: "Blind Single Object Control" },
  });

  // shutter

  static SlatPosition = new SignalType({
    name: "SlatPosition",
    description: { en: "Slat Position" },
  });

  /////////////////////////////////////////////

  // static SlatPositionStep = new SignalType({
  //   name: "SlatPositionStep",
  //   description: { en: "Slat Position Step" },
  // });

  // static SlatStopStep = new SignalType({
  //   name: "SlatStopStep",
  //   description: { en: "Slat Stop Step " },
  // });

  ////////////////////////////////////////////

  static SlatPositionStatus = new SignalType({
    name: "SlatPositionStatus",
    description: { en: "Slat Position Status" },
    isStatus: true,
  });

  static Diagnostic = new SignalType({
    name: "Diagnostic",
    globalGroupAdress: "31/1/30",
    description: { en: "Diagnostic" },
    isStatus: true,
  });

  static Scene = new SignalType({
    name: "Scene",
    description: { en: "Scene" },
    globalGroupAdress: "31/0/0",
    dpts: ["dpst-18-1", "dpst-17-1"],
  });

  static Lock = new SignalType({
    name: "Lock",
    description: { en: "Lock" },
    dpts: ["dpst-1-1", "dpst-1-2", "dpst-1-3", "dpst-1-11", "dpst-1-19"],
  });

  static LockStatus = new SignalType({
    name: "LockStatus",
    description: { en: "Lock Status" },
    dpts: ["dpst-1-1", "dpst-1-2", "dpst-1-3", "dpst-1-11", "dpst-1-19"],
    isStatus: true,
  });

  static ButtonLock = new SignalType({
    name: "ButtonLock",
    description: { en: "Button Lock" },
    dpts: ["dpst-1-1", "dpst-1-2", "dpst-1-3", "dpst-1-11", "dpst-1-19"],
  });
  static ButtonLockStatus = new SignalType({
    name: "ButtonLockStatus",
    description: { en: "Button Lock Status" },
    dpts: ["dpst-1-1", "dpst-1-2", "dpst-1-3", "dpst-1-11", "dpst-1-19"],
  });

  static TimeHrs55 = new SignalType({
    name: "TimeHrs55",
    description: { en: "Time (hrs 5.5)" },
    dpts: ["dpst-5-5"],
  });

  // static Stop = new SignalType({
  // name: "Stop",
  // description: { en: "Stop" },
  // });
  // static Start = new SignalType({
  // name: "Start",
  // description: { en: "Start" },
  // });

  //...Time

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Environment Signals ///////////////////////////////////////////////////////////////////////

  static Date = new SignalType({
    name: "Date",
    description: { en: "Date" },
    globalGroupAdress: "31/1/0",
  });

  static Time = new SignalType({
    name: "Time",
    description: { en: "Time " },
    globalGroupAdress: "31/1/1",
    dpts: ["dpst-7-5", "dpst-7-7", "dpst-10-1", "dpst-13-100", "@ 24 bit", "@ 24 bits", "@ 3 byte", "@ 3 bytes"],
  });

  static DateTime = new SignalType({
    name: "DateTime",
    description: { en: "Date Time" },
    globalGroupAdress: "31/1/2",
  });
  static DayNight = new SignalType({
    name: "DayNight",
    description: { en: "Day Night" },
    globalGroupAdress: "31/1/3",
  });

  static WinterSummer = new SignalType({
    name: "WinterSummer",
    description: { en: "Winter/Summer" },
    globalGroupAdress: "31/1/4",
  });

  static EnvironmentBrightness = new SignalType({
    name: "EnvironmentBrightness",
    description: { en: "Environment Brightness in LUX" },
    globalGroupAdress: "31/1/5",
  });

  static EnvironmentTemperature = new SignalType({
    name: "EnvironmentTemperature",
    description: { en: "Outdoor Temperature in Grad" },
    globalGroupAdress: "31/1/6",
  });

  static EnvironmentHumidity = new SignalType({
    name: "EnvironmentHumidity",
    description: { en: "Outdoor Humidity in %" },
    globalGroupAdress: "31/1/7",
  });

  static EnvironmentWindAlarm = new SignalType({
    name: "EnvironmentWindAlarm",
    description: { en: "Environment Wind Alarm" },
    globalGroupAdress: "31/1/8",
  });

  static EnvironmentFrostAlarm = new SignalType({
    name: "EnvironmentFrostAlarm",
    description: { en: "Environment Frost Alarm" },
    globalGroupAdress: "31/1/9",
  });

  static EnvironmentRainAlarm = new SignalType({
    name: "EnvironmentRainAlarm",
    description: { en: "Environment Rain Alarm" },
    globalGroupAdress: "31/1/10",
  });

  static EnvironmentHeatAlarm = new SignalType({
    name: "EnvironmentHeatAlarm",
    description: { en: "Environment Heat Alarm" },
    globalGroupAdress: "31/1/11",
  });

  static EnvironmentError = new SignalType({
    name: "EnvironmentError",
    description: { en: "Environment Error" },
    globalGroupAdress: "31/1/12",
  });

  ///////////////////////////////////////////////////////////////////////////////////////////////////////

  // ... forced Control
  static ForcedControl = new SignalType({
    name: "ForcedControl",
    description: { en: "Forced Control" },
    isIgnored: true,
  });

  static ForcedControlStatus = new SignalType({
    name: "ForcedControlStatus",
    description: { en: "Forced Control Status" },
    isIgnored: true,
  });

  //... Alarm (wind alerm, rain alarm, frost alarm, error alarm)
  static Alarm = new SignalType({
    name: "Alarm",
    description: { en: "Alarm" },
    isIgnored: true,
    dpts: ["dpst-1-5", "dpst-1-1"],
  });

  static StatusDisplaySwitch = new SignalType({
    name: "StatusDisplaySwitch",
    description: { en: "Status Display Switch" },
    isStatus: true,
  });

  static StatusDisplayColor = new SignalType({
    name: "StatusDisplayColor",
    description: { en: "Status Display Color" },
    isStatus: true,
  });

  static GenericValue = new SignalType({
    name: "GenericValue",
    description: { en: "Generic Value" },
    isStatus: false,
  });
}

export function descriptionForSignalType(type?: SignalType): string {
  if (type) {
    let res = state.translate("SignalTypes." + type.name, "");
    if (!res) {
      res = type.description?.en || type.name;
    }

    return res;
  } else {
    return "--??--";
  }
}

export function shortDescriptionForSignalType(type?: SignalType): string {
  if (!type) {
    return "--??--";
  }

  return state.translate(`SignalTypes.short.${type.name}`, "") || descriptionForSignalType(type);
}

export function getSignalTypeByName(name: string): SignalType {
  for (let st in SignalTypes) {
    if (SignalTypes[st].name == name) {
      return (SignalTypes as any)[st];
    }
  }
  return SignalTypes.Unknown;
}

(window as any).getSignalTypeByName = getSignalTypeByName;
